import "./IntelligentAutomation.css";

const IntelligentAutomation = () => {
  return (
    <section className="ia-section">
      <div className="container">
        <h2 className="ia-heading">
          Our Intelligent Automation Consulting Services
        </h2>

        <div className="row g-4">
          {/* Strategy */}
          <div className="col-lg-6">
            <div className="ia-card">
              <div className="ia-icon">💡</div>
              <h3>Strategy</h3>
              <p>
                We assess your organization’s digital maturity and create a
                strategic automation roadmap that aligns with your
                organization’s objectives.
              </p>
              <a href="#">Strategy Services →</a>
            </div>
          </div>

          {/* Implementation */}
          <div className="col-lg-6">
            <div className="ia-card">
              <div className="ia-icon">⚙️</div>
              <h3>Implementation</h3>
              <p>
                We meet you anywhere on your automation journey—from designing
                POCs and pilots to deploying automations enterprise-wide.
              </p>
              <a href="#">Implementation Services →</a>
            </div>
          </div>

          {/* Center of Excellence */}
          <div className="col-lg-6">
            <div className="ia-card">
              <div className="ia-icon">🏗️</div>
              <h3>Center of Excellence</h3>
              <p>
                Scale automation at the enterprise level with a governance model
                that aligns people, processes, and technology.
              </p>
              <a href="#">CoE Development →</a>
            </div>
          </div>

          {/* Support & Maintenance */}
          <div className="col-lg-6">
            <div className="ia-card">
              <div className="ia-icon">🛠️</div>
              <h3>Support & Maintenance</h3>
              <p>
                Flexible support via managed services, ongoing admin support,
                or continuous automation enhancements.
              </p>
              <a href="#">Support & Maintenance →</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntelligentAutomation;
